import React from 'react';
import { AlertTriangle, Scale, DollarSign, UserCheck } from 'lucide-react';

const WhatWeDont = () => {
  const boundaries = [
    {
      icon: <Scale className="h-6 w-6 text-burnt-orange" />,
      text: "high-level legal work (we can assist with admin around it)"
    },
    {
      icon: <DollarSign className="h-6 w-6 text-burnt-orange" />,
      text: "financial control decisions (we can help organize and track)"
    },
    {
      icon: <AlertTriangle className="h-6 w-6 text-burnt-orange" />,
      text: "anything unethical, misleading, or non-compliant"
    },
    {
      icon: <UserCheck className="h-6 w-6 text-burnt-orange" />,
      text: "tasks that require licensed professionals (we coordinate instead)"
    }
  ];

  return (
    <section id="what-we-dont" className="section-padding bg-white">
      <div className="container-center">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center space-y-6 mb-16 animate-slide-up">
            <h2 className="font-display text-4xl lg:text-5xl font-bold text-olive-brown">
              Clear boundaries = better support.
            </h2>
          </div>

          {/* Content */}
          <div className="space-y-8">
            <div className="text-center">
              <p className="text-xl text-olive-brown/80 mb-8">We typically don't handle:</p>
            </div>
            
            {/* Boundaries */}
            <div className="space-y-6">
              {boundaries.map((boundary, index) => (
                <div 
                  key={index}
                  className="flex items-start space-x-4 p-6 bg-gray-50 rounded-xl animate-slide-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="p-2 bg-white rounded-full mt-1">
                    {boundary.icon}
                  </div>
                  <p className="text-olive-brown/80 leading-relaxed">
                    {boundary.text}
                  </p>
                </div>
              ))}
            </div>
            
            {/* Bottom Message */}
            <div className="text-center pt-8 border-t border-olive-brown/20">
              <p className="text-burnt-orange font-medium italic">
                If it's sensitive or specialized, we help you route it properly.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDont;